import { IButtonStyles } from '@fluentui/react/lib/Button';
import { getFocusStyle } from '@fluentui/react/lib/Styling';
import { TeamsThemeDefault } from '../teams-theme';

const inset = 2;

export const CommandBarButtonStyles: Partial<IButtonStyles> = {
  root: {
    ...getFocusStyle(TeamsThemeDefault, inset)
  }
};
